import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined'
import { Chip, Tooltip } from '@mui/material'

import { Roles } from 'constants/index'
import { useGetCustomerProfileQuery } from 'generated/graphql'
import { useUserRole } from 'hooks/useUserRole'

interface AccountOnHoldStatusProps {
  reason?: string
}

const AccountOnHoldStatus = ({ reason }: AccountOnHoldStatusProps) => {
  const currentUserRole = useUserRole()

  const { data } = useGetCustomerProfileQuery({
    fetchPolicy: 'cache-and-network',
    skip: currentUserRole !== Roles.customer,
  })

  return data?.customerProfile?.isOnHold ? (
    <Tooltip
      title={
        reason ??
        'On Hold: New quotes and bookings are currently unavailable for your account. Please contact FPL team for support.'
      }
      arrow
      placement='top'>
      <Chip
        icon={<ReportOutlinedIcon />}
        label='ON HOLD'
        size='medium'
        aria-label='Account is on hold'
        sx={{
          backgroundColor: 'error.50',
          color: 'error.dark',
          border: 1,
          borderColor: 'error.light',
          fontWeight: 700,
          letterSpacing: '0.04em',
          cursor: 'help',

          '& .MuiChip-icon': {
            color: 'error.main',
          },
        }}
      />
    </Tooltip>
  ) : (
    <></>
  )
}

export default AccountOnHoldStatus
